import { useQuery, useMutation } from '@apollo/client';
import { GET_INVOICE, APPROVE_INVOICE, REJECT_INVOICE,MODIFY_INVOICE } from '../services/graphql';
import { useDispatch } from "react-redux";
import {
  userLoginSuccess,
  userLoginError,
} from "../store/actions/graphqlActions";
import keycloak from "../keycloak";

const resolveCurrentEmail = () => keycloak?.tokenParsed?.email || sessionStorage.getItem("email") || null;

const useApproval = (invoiceID) => {
    const dispatch = useDispatch();
    
    const { loading, error, data, refetch } = useQuery(GET_INVOICE, {
        variables: { invoiceID: invoiceID },
    });

    const [invoiceApproval] = useMutation(APPROVE_INVOICE, {
        onCompleted: (data) => {
            console.log("invoice approval", data);
            const status = data.approveInvoice.status;
            if (status.authorized) {
                localStorage.setItem("authorized", status.authorized);
                localStorage.setItem("access_level", status.accessLevel);
                dispatch(userLoginSuccess({ email: resolveCurrentEmail() }));
            } else {
                dispatch(userLoginError());
            }
        }
    });

    const approveInvoices = async (invoiceID) => {   
        try {
          await invoiceApproval({ variables: { invoiceID: invoiceID } });
        } catch (error) {
            console.log("Error approving invoice:", error);
            alert("Failed to approve invoice. Please try again.");
        }
    }

    // Approve the batch invoice data, if an invoice within the batch fails, show user which invoice # failed
    const approveBatchInvoices = async (invoiceIDs, setApprovalModal) => {
        const promises = invoiceIDs.map(async (invoiceID) => {
            try {
                invoiceID = invoiceID.toString();
                await invoiceApproval({ variables: {invoiceID} });
                return true;
            } catch (error) {
                console.error(`Error approving invoice ${invoiceID}:`, error);
                return false;
            }
        });
    
        try {
            const results = await Promise.all(promises);
            const allSuccessful = results.every(result => result);
    
            if (allSuccessful) {
                setApprovalModal(true);
            } else {
                const failedInvoiceApproval = invoiceIDs.filter((_, index) => !results[index]);
                alert(`Unable to approve invoices: ${failedInvoiceApproval.join(', ')}`);
            }
        } catch (error) {
            console.error('Error approving invoices:', error);
        }
    };

    const [invoiceReject] = useMutation(REJECT_INVOICE, {
        onCompleted: (data) => {
            const status = data.rejectInvoice.status;
            if (status.authorized) {
                localStorage.setItem("authorized", status.authorized);
                localStorage.setItem("access_level", status.accessLevel);
                dispatch(userLoginSuccess({ email: resolveCurrentEmail() }));
            } else {
                dispatch(userLoginError());
            }
        }
    });

    const rejectInvoice = async (invoiceID, reason, editRequired = false) => {   
        try {
          const { data } = await invoiceReject({
            variables: { invoiceID: invoiceID, reason: reason, editRequired: editRequired }
          });
          const statusCode = data?.rejectInvoice?.status?.statusCode;
          if (statusCode !== "200") {
            throw new Error(data?.rejectInvoice?.body || "Reject invoice failed");
          }
          return data;
        } catch (error) {
            console.error("Reject invoice failed:", error);
            alert("Failed to reject invoice. Please try again.");
            throw error;
        }
    }

    const [invoiceModification] = useMutation(MODIFY_INVOICE, {
        onCompleted: (data) => {
            const status = data.modifyInvoice.status;
            if (status.authorized) {
                localStorage.setItem("authorized", status.authorized);
                localStorage.setItem("access_level", status.accessLevel);
                dispatch(userLoginSuccess({ email: resolveCurrentEmail() }));
            } else {
                dispatch(userLoginError());
            }
        }
    });

    const modifyInvoice = async (invoiceData) => {
        try {
            await invoiceModification({ variables: invoiceData });
        } catch (error) {
            console.error(error);
            alert("Failed to modify invoice. Please try again.");
        }
    };
    
    
    return {loading, error, data, refetch, approveInvoices, approveBatchInvoices, rejectInvoice, modifyInvoice};

};

export default useApproval;
